import classNames from 'classnames';
import { useState } from 'react';
import { SpriteSvg, SpriteSvgType } from '../../../../components/sprite-svg';
import { ISystemMenuItem, SystemMenuId } from '../../../../model/system/menu';

import { MenuItem } from './menu-item';
import { useHistory } from 'react-router-dom';

interface IProps {
  readonly menu: ISystemMenuItem;
  readonly selectedMenuId: number | SystemMenuId | null;
}

export const MenuGroup = (props: IProps) => {
  const history = useHistory();
  const [open, setOpen] = useState<boolean>(true);
  const onMenuExpand = () => {
    if (!props.menu.subMenus) {
      if (props.menu.url) {
        history.push(props.menu.url);
        return;
      }
    }
    setOpen(!open);
  };
  const renderMenuItem = () => {
    if (
      !props.menu.hidden &&
      Array.isArray(props.menu.subMenus) &&
      props.menu.subMenus.length > 0
    ) {
      return (
        <div className="group-body">
          <ul className="sidebar-nav">
            {props.menu.subMenus.map((menu) => (
              <MenuItem
                key={menu.id}
                menu={menu}
                selectedMenuId={props.selectedMenuId}
                isSubMenu
              />
            ))}
          </ul>
        </div>
      );
    }
  };
  return (
    <div className={classNames('sidebar-nav-group', open ? 'open' : '')}>
      <div
        onClick={onMenuExpand}
        className={classNames(
          'group-head',
          props.menu.id === props.selectedMenuId ? 'active' : ''
        )}
      >
        <div className="col-icon">
          <span className="dot">
            <i></i>
          </span>
        </div>
        <div className="col-title">{props.menu.name}</div>
        {props.menu.subMenus && (
          <div className="col-arrow">
            <SpriteSvg type={SpriteSvgType.ExpandArrow} />
          </div>
        )}
      </div>
      {renderMenuItem()}
    </div>
  );
};
